export default "__VITE_ASSET__CvUME6mu__"